import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store';
import {
  clearFilters,
  clearMutationError,
  confirmSaqueThunk,
  fetchSaqueDetailThunk,
  fetchSaquesThunk,
  refuseSaqueThunk,
  selectSaque,
  setFilters,
  setLimit,
  setPage,
} from '../store/slices/saques.slice';
import { SaquesFilters } from '../types/saque';

export const useSaques = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.saques);

  const refresh = useCallback(() => {
    return dispatch(
      fetchSaquesThunk({
        page: state.page,
        limit: state.limit,
        ...state.filters,
      }),
    );
  }, [dispatch, state.page, state.limit, state.filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    items: state.items,
    page: state.page,
    limit: state.limit,
    total: state.total,
    totalPages: state.totalPages,
    filters: state.filters,
    status: state.status,
    error: state.error,
    setFilters: (filters: SaquesFilters) => dispatch(setFilters(filters)),
    clearFilters: () => dispatch(clearFilters()),
    setPage: (page: number) => dispatch(setPage(page)),
    setLimit: (limit: number) => dispatch(setLimit(limit)),
    refresh,
    selectedSaqueId: state.selectedSaqueId,
    selectedDetail: state.selectedDetail,
    detailStatus: state.detailStatus,
    detailError: state.detailError,
    openDrawer: (id: string) => {
      dispatch(selectSaque(id));
      return dispatch(fetchSaqueDetailThunk(id));
    },
    closeDrawer: () => dispatch(selectSaque(null)),
    confirm: async (id: string) => {
      const result = await dispatch(confirmSaqueThunk(id));
      if (confirmSaqueThunk.fulfilled.match(result)) {
        await refresh();
      }
      return result;
    },
    refuse: async (id: string) => {
      const result = await dispatch(refuseSaqueThunk(id));
      if (refuseSaqueThunk.fulfilled.match(result)) {
        await refresh();
      }
      return result;
    },
    mutating: state.mutating,
    mutationError: state.mutationError,
    clearMutationError: () => dispatch(clearMutationError()),
  };
};
